import {createAction} from "@reduxjs/toolkit";

const staffMemberRolesChanged = createAction<{courseIds: number[]}>(
	"courses/staffMemberRolesChanged"
);

export default staffMemberRolesChanged;
